<template>
  <button :type="type" class="btn bt-301">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "Bt301",
  props:{
    type: {
      default: 'button'
    }
  }
}
</script>

<style scoped>
.bt-301 {
  -webkit-animation: shadow-pulse 1.5s infinite;
  animation: shadow-pulse 1.5s infinite;
}


@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
  }
  100% {
    box-shadow: 0 0 0 18px rgba(0, 0, 0, 0);
  }
}
</style>